import cx from "classnames";
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { AlertType } from "../../interfaces/enums";
import { AlertContent } from "../../interfaces/interfaces";
import IconButton from "../IconButton/IconButton";
import Icon from "../Icon/icon";

interface Props {
  content: AlertContent | null;
  onClick: React.Dispatch<React.SetStateAction<AlertContent | null>>;
  durationMs?: number; // optional auto-close duration
}

const Toast = ({ content, onClick, durationMs = 10000 }: Props) => {
  // Auto-dismiss after a delay when content is present
  useEffect(() => {
    if (!content) return;
    const id = window.setTimeout(() => onClick(null), durationMs);
    return () => window.clearTimeout(id);
  }, [content, durationMs, onClick]);

  if (content && content.type && content.message) {
    const { type, message } = content;
    const success = type === AlertType.Success;
    const warning = type === AlertType.Warning;
    const error = type === AlertType.Error;
    const toastEl = (
      <div
        className={cx({
          toast: true,
          success,
          warning,
          error,
        })}
        onClick={() => onClick(null)}
        role="dialog"
      >
        <div className="toast-icon">
          {success && <Icon name="CheckCircle" iconWidth="1.5rem" />}
          {warning && <Icon name="ExclamationCirlce" iconWidth="1.5rem" />}
          {error && <Icon name="TimesCircle" iconWidth="1.5rem" />}
        </div>
        {message}
        <div className="close-button">
          <IconButton>
            <Icon name="Times" />
          </IconButton>
        </div>
      </div>
    );

    // Escape parent stacking contexts (position: relative/sticky/transform/opacity)
    if (typeof document !== "undefined") {
      return createPortal(toastEl, document.body);
    }
    return toastEl;
  } else return <></>;
};

export default Toast;
